import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import API, { mensajeDeError } from '../api';
import './Login.css';
import { useT } from '../i18n';
import LangToggle from '../components/LangToggle';
import { IS_PHONE } from '../device';
import { useLogo } from '../theme';

// El mismo mínimo que exige el backend (MIN_PASSWORD en app/schemas.py).
// Comprobarlo también aquí no sustituye al servidor —quien quiera saltárselo
// llamará a la API directamente— pero evita un viaje de ida y vuelta para
// decirle a alguien algo que se sabe antes de pulsar el botón.
const MIN_PASSWORD = 8;

export default function Register() {
  const logoSrc = useLogo();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const navigate = useNavigate();
  const t = useT();

  const handleRegister = async (e) => {
    e.preventDefault();
    if (enviando) return;
    setError('');

    if (password.length < MIN_PASSWORD) {
      setError(t('auth.password.tooShort', { min: MIN_PASSWORD }));
      return;
    }

    setEnviando(true);
    try {
      await axios.post(`${API}/auth/register`, { name, email, password });
      // El servidor responde lo mismo tanto si la cuenta se creó como si ese
      // correo YA tenía una (así nadie puede usar este formulario para averiguar
      // quién está registrado). Por eso el aviso que se enseña aquí sirve para
      // los dos casos: en ambos, lo siguiente que hay que hacer es entrar.
      navigate('/', {
        state: {
          avisoKey: 'auth.register.done',
        },
      });
    } catch (err) {
      setError(mensajeDeError(err, t('auth.register.errorFallback')));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page">
      <LangToggle style={{ position: 'fixed', top: 12, right: 16, zIndex: 10 }} />
      {/* Teléfono: sin vídeo de fondo (pesa y gasta batería); queda el degradado. */}
      {!IS_PHONE && (
        <video className="login-video-bg" autoPlay muted playsInline loop>
          <source src="/videos/background.mp4" type="video/mp4" />
        </video>
      )}

      <div className="login-overlay" />

      <div className="login-container">
        <div className="login-card-glow">
          <div className="login-card">
            <div className="login-logo">
              <img src={logoSrc} alt="DragonAudio" className="logo-img" />
              <h1 className="login-title">DragonAudio</h1>
            </div>

            {error && <p className="login-error">{error}</p>}

            <form onSubmit={handleRegister} className="login-form">
              <input
                placeholder={t('auth.field.name')} value={name}
                onChange={e => setName(e.target.value)}
                className="login-input"
                autoComplete="name" required
              />
              <input
                type="email" placeholder={t('auth.field.email')} value={email}
                onChange={e => setEmail(e.target.value)}
                className="login-input"
                autoComplete="email" required
              />
              <input
                type="password" placeholder={t('auth.field.password')} value={password}
                onChange={e => setPassword(e.target.value)}
                className="login-input"
                autoComplete="new-password" required
              />
              <p className="login-pista">
                {t('auth.password.hint', { min: MIN_PASSWORD })}
              </p>
              <button type="submit" className="login-btn" disabled={enviando}>
                {enviando ? t('auth.register.submitting') : t('auth.register.submit')}
              </button>
            </form>

            <p className="login-register">
              {t('auth.register.haveAccount')} <Link to="/">{t('auth.register.login')}</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
